const languageRu = {
  'otherLanguage': 'RU',
};

export default languageRu;
